import { HttpParams } from "@angular/common/http";

export type ApiVersion = "V1" | "V2" | "V3";

export interface VersionedApiUrls {
  readonly V1: string;
  readonly V2: string;
  readonly V3: string;
}

export function parseApiVersion(value: string): ApiVersion {
  switch (value.toUpperCase()) {
    case "V1":
      return "V1";
    case "V2":
      return "V2";
    case "V3":
      return "V3";
    default:
      throw new Error(`Unsupported API version: ${value}`);
  }
}

export function resolveApiVersion(
  value: string,
  fallback: ApiVersion = "V3",
): ApiVersion {
  const normalized = value.toUpperCase();
  return normalized === "V1" || normalized === "V2" || normalized === "V3"
    ? normalized
    : fallback;
}

export function selectApiUrl(
  version: ApiVersion,
  urls: VersionedApiUrls,
): string {
  return urls[version];
}

export type QueryValue = string | number | boolean | null | undefined;

export function createHttpParams(
  values: Readonly<Record<string, QueryValue>>,
): HttpParams {
  return Object.entries(values).reduce((params, [key, value]) => {
    if (value === null || value === undefined) {
      return params;
    }
    return params.set(key, String(value));
  }, new HttpParams());
}

export function appendHttpParams(url: string, params: HttpParams): string {
  const query = params.toString();
  return query ? `${url}?${query}` : url;
}
